<header
  class="page-header"
  [mmTestId]="'ALL_PAGES.SIMPLIFIED_HEADER'"
>
  <div class="container">
    <a *ngIf="!isMCompanion" class="page-header__logo" href="/" [attr.aria-label]=" 'CHECKOUT.A11Y.TITLE.METRO_MARKETS' | translate ">
      <mm-icon type="fluid" [name]="logoClassName"></mm-icon>
    </a>
    <div
      *ngIf="!isMobile; else mobileActions"
      class="page-header__actions"
      fxLayoutAlign="center center"
    >
      <mm-icon class="chat-icon" name="chat-now"></mm-icon>
      <p>
        {{ 'HEADER.SIMPLIFIED.NEED_HELP.LABEL' | frPostfix | translate }}
        <a
          target="_blank" rel="noopener noreferrer"
          [href]="helpCenterLink"
          [mmTestTarget]="'help-center-link'"
        >{{ 'HEADER.SIMPLIFIED.HELP_CENTER.LABEL' | frPostfix | translate }}</a>
        {{ 'HEADER.SIMPLIFIED.CALL.LABEL' | translate }}
        <a
          [href]="'tel:' + helpPhoneNumber"
          [mmTestTarget]="'help-support-phonenumber'"
        >
          {{ helpPhoneNumber }}
        </a>
      </p>
    </div>
  </div>
</header>

<ng-template #mobileActions>
  <div class="page-header__actions">
    <mm-icon class="chat-icon" name="chat-now"></mm-icon>
    <span
      #popoverOrigin
      class="page-header__link"
      [mmTestTarget]="'help-center-popover-open'"
      (click)="showHelpCenterPopover(popoverOrigin)"
    >
      {{ 'HEADER.SIMPLIFIED.NEED_HELP_MIN.LABEL' | frPostfix | translate }}
    </span>
  </div>
</ng-template>

<ng-template #helpPopover>
  <div
    class="help-center-popover"
    [ngStyle]="popoverStyles"
  >
    <div
      class="help-center-popover__close"
      [mmTestTarget]="'help-center-popover-close'"
      (click)="closeHelpPopover()"
    >
      <mm-icon class="close-icon" name="close" type="fluid"></mm-icon>
    </div>

    <div class="help-center-popover__link">
      <mm-icon name="help"></mm-icon>
      {{ 'HEADER.SIMPLIFIED.GO_TO.LABEL' | frPostfix | translate }}
      <a
        [href]="helpCenterLink"
        [mmTestTarget]="'help-center-popover-help-center-link'"
      >
        {{ 'HEADER.SIMPLIFIED.HELP_CENTER.LABEL' | frPostfix | translate }}
      </a>
    </div>
    <div class="help-center-popover__link">
      <app-svg-phone></app-svg-phone>
      {{ 'HEADER.SIMPLIFIED.CALL_MIN.LABEL' | translate }}
      <a
        [href]="'tel:' + helpPhoneNumber"
        [mmTestTarget]="'help-center-popover-phone-link'"
      >
        {{ helpPhoneNumber }}
      </a>
    </div>
  </div>
</ng-template>
